// extracted by LIB_CSS_EXTRACT_LOADER
import "./ripple-button_module.css"
export default {"button":"button-IxGPjV","content":"content-yAWmOo","ripple":"ripple-GAek8g"};